import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/common/login/login.component';
import { SignupComponent } from './components/common/signup/signup.component';
import { DashBoardComponent } from './components/pages/dash-board/dash-board.component';
import { AccountComponent } from './components/pages/account/account.component';
import { DevicesScreenComponent } from './components/pages/devices-screen/devices-screen.component';
import { ChatComponent } from './components/pages/chat/chat.component';
import { ConnectnewDeviceComponent } from './components/pages/connectnew-device/connectnew-device.component';
import { UsersComponent } from './components/pages/users/users.component';
import { RestorePasswordComponent } from './components/common/restore-password/restore-password.component';
import { SettingsComponent } from './components/pages/settings/settings.component';
import { CampaignsComponent } from './components/pages/campaigns/campaigns.component';
import { WelcomeComponent } from './components/welcome/welcome.component'; 
import { EnvioMasivoMensajeComponent } from './components/pages/campaigns/envio-masivo-mensaje/envio-masivo-mensaje.component';
import { EnvioMasivoArchivoComponent } from './components/pages/campaigns/envio-masivo-archivo/envio-masivo-archivo.component';
import { MensajePersonalizadoGrupoComponent } from './components/pages/campaigns/mensaje-personalizado-grupo/mensaje-personalizado-grupo.component';
import { ArchivoPersonalizadoGrupoComponent } from './components/pages/campaigns/archivo-personalizado-grupo/archivo-personalizado-grupo.component';
import { ListaDeContactosComponent } from './components/pages/campaigns/lista-de-contactos/lista-de-contactos.component';
import { MisCampaniasComponent } from './components/pages/campaigns/mis-campanias/mis-campanias.component';
import { CrearContactosComponent } from './components/pages/campaigns/crear-contactos/crear-contactos.component';
import { EditarContactosComponent } from './components/pages/campaigns/editar-contactos/editar-contactos.component';
import { MisCampaniasDetallesComponent } from './components/pages/campaigns/mis-campanias-detalles/mis-campanias-detalles.component';
import { AuthGuard } from './guards/auth.guard';


const routes: Routes = [

  { path: '', redirectTo: '/welcome', pathMatch: 'full' }, 
  { path: 'welcome', component: WelcomeComponent }, 
  { path: 'login', component: LoginComponent }, 
  { path: 'signup', component: SignupComponent },
  { path: 'restore-password',component:RestorePasswordComponent},
  { path: 'dashboard', component: DashBoardComponent, canActivate: [AuthGuard] },
  { path: 'account', component: AccountComponent, canActivate: [AuthGuard] },
  { path: 'devices', component: DevicesScreenComponent, canActivate: [AuthGuard]},
  { path: 'chat', component: ChatComponent, canActivate: [AuthGuard]},
  { path:'', component:LoginComponent, canActivate: [AuthGuard]},
  { path:'home',component:DashBoardComponent, canActivate: [AuthGuard]},
  { path: 'connect',component:ConnectnewDeviceComponent, canActivate: [AuthGuard]},
  { path: 'users',component:UsersComponent, canActivate: [AuthGuard]},
  { path: 'settings',component:SettingsComponent, canActivate: [AuthGuard]},
  { path: 'campaigns',component:CampaignsComponent, canActivate: [AuthGuard]},
  { path: 'message-multiple-contacts', component: EnvioMasivoMensajeComponent, canActivate: [AuthGuard]},
  { path: 'file-multiple-contacts', component: EnvioMasivoArchivoComponent, canActivate: [AuthGuard]},
  { path: 'personalized-message-multiple-contacts', component: MensajePersonalizadoGrupoComponent, canActivate: [AuthGuard]},
  { path: 'personalized-file-multiple-contacts', component: ArchivoPersonalizadoGrupoComponent, canActivate: [AuthGuard]},
  { path: 'contact-list', component: ListaDeContactosComponent, canActivate: [AuthGuard]},
  { path: 'my-campaigns',component:MisCampaniasComponent, canActivate: [AuthGuard]},
  { path: 'new-list', component:CrearContactosComponent, canActivate: [AuthGuard]},
  { path: 'campaign-detail/:id', component:MisCampaniasDetallesComponent, canActivate: [AuthGuard]},
  { path: 'edit-list/:id', component:EditarContactosComponent, canActivate: [AuthGuard]}, //{ path: 'edit-list', component:EditarContactosComponent},
  // Redirigir cualquier ruta no encontrada a login
  { path: '**', redirectTo: 'welcome' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
